import styled from 'styled-components';
import Button from '@/trio-ui/Button';
import InputText from '@/trio-ui/InputText';
import CandidateListCard from '../CandidateListCard';

export const Box = styled.div`
  position: relative;
`;

export const Input = styled(InputText)`
  width: 100%;
  padding-top: 4.5px !important;
  padding-bottom: 4.5px !important;

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colors['neutral-0']};
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
  border-radius: 4px;
  overflow: hidden;
  z-index: 1;
  max-height: 400px;
  overflow-y: auto;
`;

export const ListItem = styled.div`
  position: relative;

  > button {
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors['neutral-20']};

    > button {
      display: block;
    }

    > div {
      opacity: 0.25;
    }
  }
`;

export const ActivateButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const CandidateCard = styled(CandidateListCard)`
  background-color: transparent;
`;

export const CancelButton = styled.button`
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.colors['neutral-40']};
  z-index: 1;
  padding: 8px;

  & > svg {
    display: block;
    width: 10px;
    height: 10px;
  }
`;

export const LoadingContainer = styled.div`
  padding: 20px;
`;
